import buttonGlobalPlayer from '@/components/button-global-player/button-global-player.vue'
import iconOpenInNew from '@/components/icons/icon-open-in-new.vue'
import modalEntry from '@/components/modal-entry/modal-entry.vue'

export default {
  components: {
    buttonGlobalPlayer,
    iconOpenInNew,
    modalEntry
  },
  data () {
    return {
      isOpen: false,
      showModalUpdateDetails: false
    }
  },
  computed: {
    phoneNumber07 () {
      return `0${this.phoneNumber.substring(2)}`
    }
  },
  methods: {
    toggleOpen () {
      this.isOpen = !this.isOpen
    },
    loginWithGlobalPlayer () {
      this.$router.push({ name: 'login' })
    },
    reloginWithGlobalPlayer () {
      this.logout()
      this.$router.push({ name: 'login' })
    },
    onClickUpdateDetails () {
      this.isOpen = false
      this.showModalUpdateDetails = true
      this.$router.push({ name: 'global-player-settings' })
    },
    logout () {
      this.$store.dispatch('auth/logout')
    }
  }
}
